import {Component} from 'react';
import * as Weirwood from '@baidu/weirwood-sdk';

const options = {
    common: {
        buildid: '209',
        token: '9cf86b9c9d8a4ff68c3b36cb22e86fa1',
    },
    error: {
        collectWindowErrors: true,
        collectUnhandledRejections: true,
        ignoreUrls: [
            // 本地开发屏蔽错误发送，请按需修改
            'localhost',
            '127.0.0.1',
        ],
    },
    perf: {
        sampleRate: 1,
        spa: true,
        history: true,
        ignoreUrls: [
            // 本地开发屏蔽错误发送，请按需修改
            'localhost',
            '127.0.0.1',
        ],
    },
};

const weirwood = Weirwood.init(options);

export class WeirwoodErrorBoundary extends Component {
    constructor(props: any) {
        super(props);
        this.state = {hasError: false};
    }
    static getDerivedStateFromError() {
        return {hasError: true};
    }
    componentDidCatch(error: any) {
        weirwood.error.captureException(error);
    }
    render() {
        return this.props.children;
    }
}
